import React from 'react';
import DealerInfoLayout from '../DealerInfoLayout';
import usePrequal from '../../resources/prequal/usePrequal';

const DealerInfo = ({
  control,
  selectedMerchantId,
  onMerchantChange,
  onShowRepairFinder,
}) => {
  const { data: prequal } = usePrequal();

  if (prequal.merchantId && prequal.advisorId) {
    return null;
  }

  if (prequal.merchantId) {
    return (
      <DealerInfoLayout
        title="Who are you working with?"
        subtitle="Select the advisor who's assisting you."
        control={control}
        selectedMerchantId={prequal.merchantId}
      />
    );
  }

  return (
    <DealerInfoLayout
      showMerchantSelect
      title="Where are you doing business?"
      subtitle="Select the service center and advisor who's assisting you."
      control={control}
      selectedMerchantId={selectedMerchantId}
      onMerchantChange={onMerchantChange}
      onShowRepairFinder={onShowRepairFinder}
    />
  );
};

export default DealerInfo;
